import React, { Component } from "react";
import Breadcrumb from "../../common/breadcrumb";
import { getCall, postCall } from "../../../api/post";
import {
  loadUserDetailsFromLocalStorage,
  getValueFromLanguageObject,
  getColorCodeBasedOnKey,
} from "../../../store";
import { getNotificationCounter } from "../../../actions";
import { connect } from "react-redux";
import {
  getMasterDetailsIdUrl,
  getMerchantInformationUrl,
} from "../../../services";
import { Helmet } from "react-helmet";
import MainLoader from "../../../animation/MainLoader";
import ErrorMessageAnimationModal from "../../../animation/ErrorMessageAnimationModal";
import SuccessMessageAnimationModal from "../../../animation/SuccessMessageAnimationModal";
import {
  clearLocalStorageReload,
  isOpenStoreIdExist,
  navigateTo,
  removeUserDetailAndOtherDetails,
} from "../../../utils/utils";
import { withRouter } from "react-router-dom";
import { getsubmitfeedbackUrl } from "../../../services";

class ContactUs extends Component {
  state = {
    contactUs: {},
    isLoading: true,
    AppTitle: "",
    showErrorMessageModal: false,
    errorMessage: "",
    masterDetailsObj: {},
    userName: "",
    email: "",
    contactNumber: "",
    inquiryMsg: "",
    showSuccessMessageModal: false,
    successMessage: "",
  };
  componentDidMount() {
    // Authentication/redirection moved to central route guard (PrivateRoute).
    const userDetails = loadUserDetailsFromLocalStorage();
    this.setState({
      userName: (userDetails && userDetails.username) ? userDetails.username : "",
      email: (userDetails && userDetails.email) ? userDetails.email : "",
    });
    this.initMasterDetailsId().then(() => {
      this.initMerchantInfo();
      this.initContactUs().then(() => {
        this.setState({ isLoading: false });
      });
      this.props.notificationCounter();
    });
  }

  initMasterDetailsId = async () => {
    let masterDetailsObj = {};
    const publicUrl = window.location.pathname.split("/")[1];
    const masterDetailsIdUrl = getMasterDetailsIdUrl(publicUrl);
    const masterDetails = await getCall(masterDetailsIdUrl, []).then();
    if (masterDetails.error) {
      clearLocalStorageReload({ response: masterDetails });
    } else {
      if (masterDetails) {
        masterDetailsObj = masterDetails;
      }
    }
    this.setState({ masterDetailsObj: masterDetailsObj });
  };

  initContactUs = async () => {
    const { masterDetailsObj } = this.state;
    const userDetails = loadUserDetailsFromLocalStorage();
    if (!isOpenStoreIdExist() && userDetails === undefined) {
      navigateTo(this.props, `/login`);
      return;
    }

    const contantusUrl = getMerchantInformationUrl(masterDetailsObj);
    const contactUs = await getCall(contantusUrl, []);
    if (contactUs.error) {
      clearLocalStorageReload({ response: contactUs });
      this.loadErrorMessageAnimation(contactUs.error.message);
      if (contactUs.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      this.setState({ contactUs });
    }
  };

  initMerchantInfo = async () => {
    const { masterDetailsObj } = this.state;
    const merchantInfoUrl = getMerchantInformationUrl(masterDetailsObj);
    const merchantInfo = await getCall(merchantInfoUrl, []);
    if (merchantInfo.error) {
      clearLocalStorageReload({ response: merchantInfo });
      this.setState({
        AppTitle: "",
      });
    } else {
      this.setState({
        AppTitle: merchantInfo.companyname,
      });
    }
  };

  loadErrorMessageAnimation = (message) => {
    this.setState({ errorMessage: message, showErrorMessageModal: true });
  };

  loadSuccessMessageAnimation = (message) => {
    this.setState({ successMessage: message, showSuccessMessageModal: true });
  };

  handleChangeOfUserName = (event) => {
    this.setState({ userName: event.target.value });
  };
  handleChangeOfEmail = (event) => {
    this.setState({ email: event.target.value });
  };
  handleChangeOfinquiryMsg = (event) => {
    this.setState({ inquiryMsg: event.target.value });
  };

  onClickOfSubmit = () => {
    const { inquiryMsg, userName, email } = this.state;

    if (!userName.trim()) {
      this.loadErrorMessageAnimation("Please enter your name");
      return;
    }
    if (!email.trim()) {
      this.loadErrorMessageAnimation("Please enter your email");
      return;
    }
    if (!inquiryMsg.trim()) {
      this.loadErrorMessageAnimation("Please enter description");
      return;
    }

    window.grecaptcha.ready(() => {
      window.grecaptcha.execute('6LcehcQrAAAAAHnnXqZikUk09q5wpKjkitQKffII', { action: 'submit' }).then((token) => {
        this.setState({ isLoading: true }, async () => {
          const submitFeedbackUrl = getsubmitfeedbackUrl();
          const contactUsFeedback = await postCall(submitFeedbackUrl, {
            username: userName,
            email: email,
            description: inquiryMsg,
            recaptchaToken: token,
          });
          this.setState({ isLoading: false });

          // Handle daily feedback limit error
          if (
            contactUsFeedback &&
            contactUsFeedback.success === false &&
            contactUsFeedback.message
          ) {
            this.loadErrorMessageAnimation(contactUsFeedback.message);
            return;
          }

          if (contactUsFeedback.error) {
            clearLocalStorageReload({ response: contactUsFeedback });
            this.loadErrorMessageAnimation(contactUsFeedback.error.message);
            if (contactUsFeedback.error.statusCode === 401) {
              removeUserDetailAndOtherDetails();
              navigateTo(this.props, `/login`);
              return;
            }
          } else {
            this.loadSuccessMessageAnimation(
              "Thank you for your message. You will receive a response by our team"
            );
            this.setState({ inquiryMsg: "", userName: "", email: "" });
          }
        });
      });
    });
  };

  render() {
    const {
      contactUs,
      isLoading,
      AppTitle,
      showErrorMessageModal,
      errorMessage,
      showSuccessMessageModal,
      successMessage,
    } = this.state;
    return (
      <>
        <div>
          <Helmet>
            <title>
              {AppTitle} |{" "}
              {getValueFromLanguageObject("str_contact_us")
                ? getValueFromLanguageObject("str_contact_us")
                : "Contact Us"}
            </title>
            <meta
              name="description"
              content="Multikart – Multipurpose eCommerce React Template is a multi-use React template. It is designed to go well with multi-purpose websites. Multikart Bootstrap 4 Template will help you run multiple businesses."
            />
          </Helmet>
          <Breadcrumb
            title={
              getValueFromLanguageObject("str_contact_us")
                ? getValueFromLanguageObject("str_contact_us")
                : "Contact Us"
            }
          />

          <section className="contact-page section-b-space">
            <div className="container" style={{ paddingTop: 0 }}>
              <h2
                style={{
                  marginBottom: "24px",
                  marginTop: "0px",
                  paddingTop: "0px", // <-- Ensure no padding
                }}
              >
                {getValueFromLanguageObject("str_how_can_we_help_you")
                  ? getValueFromLanguageObject("str_how_can_we_help_you")
                  : "HOW CAN WE HELP YOU?"}
              </h2>
              <div
                className="row section-b-space"
                style={{
                  alignItems: "flex-start",
                  marginTop: 0, // <-- Remove row top margin
                  paddingTop: 0, // <-- Remove row top padding
                }}
              >
                <div
                  className="col-lg-7 map"
                  style={{
                    border: "2px solid #ddd",
                    borderRadius: "16px",
                    background: "#fff",
                    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                    marginTop: "0px",
                    padding: "16px 16px 16px 16px", // <-- Reduce padding
                  }}
                >
                  <form
                    className="theme-form"
                    style={{
                      margin: "0 8px 8px 8px",
                      paddingTop: "0px",
                    }}
                  >
                    <div className="form-row">
                      <div className="form-group col-md-12 mb-2">
                        <label htmlFor="userName">
                          {getValueFromLanguageObject("str_username") || "Username"}
                          <span style={{ color: "red", marginLeft: 4 }}>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="userName"
                          placeholder={
                            getValueFromLanguageObject("str_enter_your_name") ||
                            "Enter Your Name"
                          }
                          value={this.state.userName}
                          onChange={this.handleChangeOfUserName}
                          required
                          style={{ fontSize: "14px" }}
                        />
                      </div>
                      <div className="form-group col-md-12 mb-2">
                        <label htmlFor="email">
                          {getValueFromLanguageObject("str_email") || "Email"}
                          <span style={{ color: "red", marginLeft: 4 }}>*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder={
                            getValueFromLanguageObject("str_enter_your_email") ||
                            "Enter Your Email"
                          }
                          value={this.state.email}
                          onChange={this.handleChangeOfEmail}
                          required
                          style={{ fontSize: "14px" }}
                        />
                      </div>
                      <div className="form-group col-md-12">
                        <label htmlFor="inquiryMsg">
                          {getValueFromLanguageObject("leave_your_message") ||
                            "Leave Your Message"}
                          <span style={{ color: "red", marginLeft: 4 }}>*</span>
                        </label>
                        <textarea
                          className="form-control"
                          id="inquiryMsg"
                          placeholder={
                            getValueFromLanguageObject("str_enter_your_message")
                              ? getValueFromLanguageObject(
                                  "str_enter_your_message"
                                )
                              : "Enter Your Message"
                          }
                          rows="6"
                          minLength="5"
                          maxLength="512"
                          value={this.state.inquiryMsg}
                          onChange={this.handleChangeOfinquiryMsg}
                          style={{ fontSize: "14px" }}
                        />
                      </div>
                    </div>
                    <div className="form-row">
                      <div
                        onClick={() => {
                          this.onClickOfSubmit();
                        }}
                        className="btn btn-solid"
                      >
                        {getValueFromLanguageObject("submit")
                          ? getValueFromLanguageObject("submit")
                          : "Submit"}
                      </div>
                    </div>
                  </form>
                </div>
                <div className="col-lg-5" style={{ marginTop: "0px", paddingTop: "0px" }}>
                  <div className="contact-right" style={{ marginTop: "0px", paddingTop: "0px" }}>
                    <div
                      className="contact-card"
                      style={{
                        background: "#fff",
                        borderRadius: "16px",
                        boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                        padding: "24px",
                        minHeight: "180px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginTop: "0px", // <-- Remove top margin
                        marginBottom: "8px",
                        border: "1px solid #e5e7eb",
                      }}
                    >
                      <img
                        src="/assets/images/logo.png"
                        alt="logo"
                        height="80px"
                        style={{ marginBottom: "16px" }}
                      />
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "14px",
                          color: "#222",
                        }}
                      >
                        {contactUs.cellnumber && (
                          <div style={{ marginBottom: "8px" }}>
                            <i
                              className="fa fa-phone"
                              style={{ color: "#FF6A00", marginRight: "8px" }}
                            />
                            <span style={{ fontWeight: "bold" }}>Call Us:</span>{" "}
                            {contactUs.cellnumber}
                          </div>
                        )}
                        {contactUs.email && (
                          <div>
                            <i
                              className="fa fa-envelope"
                              style={{ color: "#FF6A00", marginRight: "8px" }}
                            />
                            <span style={{ fontWeight: "bold" }}>Email:</span>{" "}
                            {contactUs.email}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>{" "}
              {/* <-- This closes the row */}
            </div>
          </section>
          {isLoading && <MainLoader />}
        </div>
        {showErrorMessageModal && (
          <ErrorMessageAnimationModal
            show={showErrorMessageModal}
            message={errorMessage}
            onClose={() => {
              this.setState({ showErrorMessageModal: false });
            }}
          />
        )}
        {showSuccessMessageModal && (
          <SuccessMessageAnimationModal
            show={showSuccessMessageModal}
            message={successMessage}
            onClose={() => {
              this.setState({ showSuccessMessageModal: false });
            }}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
  notificationCounter: getNotificationCounter,
})(withRouter(ContactUs));
